import { render, staticRenderFns } from "./meritoClassify.vue?vue&type=template&id=08f01995&"
import script from "./meritoClassify.vue?vue&type=script&lang=js&"
export * from "./meritoClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports